import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'الرئيسية' },
    { path: '/investment-methodology', label: 'كيف نوظف رأس مالك' },
    { path: '/achievements', label: 'الإنجازات وسجل الأداء' },
    { path: '/contact', label: 'تواصل معنا' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-dark-navy/95 backdrop-blur-lg shadow-lg shadow-neon-cyan/5' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/5f6efc2ffdcd0c86f2a49b96b7b50d51.png" 
              alt="طيبات الطبية العالمية" 
              className="h-8 sm:h-10 w-auto"
            />
            <span className="text-white font-bold text-sm sm:text-base hidden sm:inline">طيبات الطبية</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-neon-cyan'
                    : 'text-gray-300 hover:text-neon-cyan'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="/board/login"
              className="px-4 lg:px-5 py-2 lg:py-2.5 border-2 border-purple-500 text-purple-400 rounded-lg hover:bg-purple-500/10 transition-all font-bold whitespace-nowrap text-sm cursor-pointer"
            >
              دخول مجلس الإدارة
            </a>
            <a
              href="/admin/login"
              className="px-4 lg:px-5 py-2 lg:py-2.5 border-2 border-[#00FF94] text-[#00FF94] rounded-lg hover:bg-[#00FF94]/10 transition-all font-bold whitespace-nowrap text-sm cursor-pointer"
            >
              دخول الإدارة
            </a>
            <a
              href="/investor/login"
              className="px-4 lg:px-6 py-2 lg:py-2.5 bg-gradient-to-r from-[#00D9FF] to-[#00B8D4] text-white rounded-lg hover:shadow-lg hover:shadow-[#00D9FF]/30 transition-all font-bold whitespace-nowrap text-sm cursor-pointer"
            >
              دخول المستثمرين
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white hover:text-neon-cyan transition-colors cursor-pointer"
            aria-label="القائمة"
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-700/50 pt-4 space-y-3 bg-gradient-to-b from-[#0A0F1E] to-[#0D1425] rounded-xl shadow-2xl backdrop-blur-xl">
            {/* Mobile Navigation Links */}
            <div className="space-y-2 px-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`block px-4 py-3 rounded-lg transition-all cursor-pointer ${
                    location.pathname === link.path
                      ? 'bg-neon-cyan/20 text-neon-cyan border border-neon-cyan/30'
                      : 'text-gray-200 hover:bg-gray-800/70 hover:text-neon-cyan border border-transparent'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Mobile Buttons */}
            <div className="space-y-2 pt-2 px-2 border-t border-gray-700/30 mt-3">
              <a
                href="/investor/login"
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full px-4 py-3 bg-gradient-to-r from-[#00D9FF] to-[#00B8D4] text-white rounded-lg hover:shadow-lg hover:shadow-[#00D9FF]/30 transition-all font-bold text-center cursor-pointer"
              >
                دخول المستثمرين
              </a>
              <a
                href="/admin/login"
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full px-4 py-3 border-2 border-[#00FF94] text-[#00FF94] rounded-lg hover:bg-[#00FF94]/10 transition-all font-bold text-center cursor-pointer"
              >
                دخول الإدارة
              </a>
              <a
                href="/board/login"
                onClick={() => setMobileMenuOpen(false)}
                className="block w-full px-4 py-3 border-2 border-purple-500 text-purple-400 rounded-lg hover:bg-purple-500/10 transition-all font-bold text-center cursor-pointer"
              >
                دخول مجلس الإدارة
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
